import createDOMPurify from 'dompurify'

const domPurify = createDOMPurify(window)

const sanitize = (html: string | Node, options?: any) => {
  return domPurify.sanitize(html, options)
}

export default sanitize
